import React from 'react';
import { ArrowRightIcon, CheckIcon, CircleDashedIcon, LinkedinIcon } from 'lucide-react';
import { LenticMark } from '../components/LenticMark';
import { EYEBROW } from '../components/site/Band';
import { companyIntro, evidenceEstablished, evidenceInProgress, founders } from '../data/site';
export function Company() {
  return <>
      <section className="relative w-full overflow-hidden border-b border-mist bg-bone" data-id="element-423" data-mp="1e5h7bss8g1dp">
        <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-424" data-mp="gjjpzypla23c">
          <LenticMark size={560} title={null} data-id="element-425" data-mp="lhv2kh79qqp9" />
        </div>

        <div className="relative mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-426" data-mp="qfwm138lws19">
          <p className={`${EYEBROW} text-teal`} data-id="element-427" data-mp="vf983lrnlv2s">Company</p>
          <h1 className="mt-5 max-w-3xl font-display text-[40px] font-light leading-[1.05] tracking-tight text-ink sm:text-[56px]" data-id="element-428" data-mp="vgu31chvrg16">
            What we're building.
          </h1>
          <div className="mt-8 max-w-[68ch] space-y-5" data-id="element-429" data-mp="26tcxsfr7kx21">
            {companyIntro.map(line => <p key={line} className="text-xl leading-relaxed text-graphite" data-id="element-430" data-mp="2a9of3ohkblp5">
                {line}
              </p>)}
          </div>
        </div>
      </section>

      <section className="w-full border-b border-mist bg-bone" data-id="element-431" data-mp="218q9x2ve184z">
        <div className="mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-432" data-mp="216x2vmgv4lwg">
          <p className={`${EYEBROW} text-teal`} data-id="element-433" data-mp="1w8vjt1jfsmkz">Founders</p>
          <h2 className="mt-5 font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-434" data-mp="1raakd4c0e6xl">
            Who is doing the work.
          </h2>

          <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-435" data-mp="1mhr7k9l5bftu">
            {founders.map(person => <li key={person.background} className="flex flex-col rounded-2xl border border-mist bg-white/70 p-8" data-id="element-436" data-mp="1hlaldkxibbje">
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-teal" data-id="element-437" data-mp="1dh2txfznzhhh">
                  {person.role}
                </span>
                <h3 className="mt-4 font-display text-2xl font-medium text-ink" data-id="element-438" data-mp="13kpxwbgncrjk">
                  {person.name}
                </h3>
                <p className="mt-3 max-w-[46ch] text-lg leading-relaxed text-graphite" data-id="element-439" data-mp="tvsvdi1wcqo8">
                  {person.background}
                </p>
                <a href={person.linkedin} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-ink transition-colors hover:text-teal" data-id="element-440" data-mp="jzg1aj2fwasy">
                  <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-441" data-mp="1co54qoqyws7v" />
                  LinkedIn
                </a>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="w-full border-b border-mist bg-bone" data-id="element-442" data-mp="1hosu75zjt0zz">
        <div className="mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-443" data-mp="12xai3j9t7qlw">
          <p className={`${EYEBROW} text-teal`} data-id="element-444" data-mp="17wdfchjjssjb">Where we are</p>
          <h2 className="mt-5 max-w-3xl font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-445" data-mp="1vmpuacd7npje">
            Early, and specific about it.
          </h2>
          <p className="mt-6 max-w-[68ch] text-xl leading-relaxed text-graphite" data-id="element-446" data-mp="20fak72szxihn">
            Stating exactly where the evidence stops is part of the product
            argument, not a caveat attached to it.
          </p>

          <div className="mt-12 grid gap-4 lg:grid-cols-2" data-id="element-447" data-mp="3utemwyqmo2am">
            <div className="rounded-2xl border border-teal/30 bg-teal/[0.05] p-8 lg:p-10" data-id="element-448" data-mp="3usv7ppsd3s0a">
              <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-teal" data-id="element-449" data-mp="3pvd50h4xu90q">
                Established
              </h3>
              <ul className="mt-7 space-y-5" data-id="element-450" data-mp="2x5w5z0mtbtvj">
                {evidenceEstablished.map(item => <li key={item} className="flex items-start gap-3" data-id="element-451" data-mp="2x80kecic8ba2">
                    <CheckIcon className="mt-1.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-452" data-mp="3b6gn7sd2xhmx" />
                    <span className="max-w-[52ch] text-lg leading-relaxed text-ink" data-id="element-453" data-mp="373amt1cnekod">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="rounded-2xl border border-mist bg-white/60 p-8 lg:p-10" data-id="element-454" data-mp="md32d13e78b3">
              <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-455" data-mp="1hp2w6zul0esd">
                In progress
              </h3>
              <ul className="mt-7 space-y-5" data-id="element-456" data-mp="1lrpeoa5d4ncw">
                {evidenceInProgress.map(item => <li key={item} className="flex items-start gap-3" data-id="element-457" data-mp="1qn4qyxnq2b77">
                    <CircleDashedIcon className="mt-1.5 h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-458" data-mp="1vo2iw1yjajlw" />
                    <span className="max-w-[52ch] text-lg leading-relaxed text-graphite" data-id="element-459" data-mp="20note3mz9lr0">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="mt-10 max-w-[70ch] font-display text-2xl font-light leading-snug text-ink" data-id="element-460" data-mp="29gihmqkejvh0">
            We publish the analysis plan before we run it, and we report the
            cases where the assessment failed to discriminate.
          </p>
        </div>
      </section>

      <section className="w-full border-b border-mist bg-bone" data-id="element-461" data-mp="2odj8ysyoloey">
        <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 py-24 lg:grid-cols-[1fr_1fr] lg:items-center lg:px-10 lg:py-32" data-id="element-462" data-mp="cp4j17dkf3ra">
          <div data-id="element-463" data-mp="7p03bjkhed24">
            <p className={`${EYEBROW} text-teal`} data-id="element-464" data-mp="7ogl01qx5mnk">Contact</p>
            <h2 className="mt-5 font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-465" data-mp="2qf1xgthtnc3">
              Talk to us directly.
            </h2>
            <p className="mt-6 max-w-[52ch] text-xl leading-relaxed text-graphite" data-id="element-466" data-mp="3tzm8pngleh2f">
              Operating buyers, candidates and investors all reach us at the
              same address.
            </p>
          </div>

          <div className="rounded-2xl border border-mist bg-white/70 p-8" data-id="element-467" data-mp="lpj6ode04uxy">
            <a href="mailto:hello@lentic.ai" className="font-display text-2xl text-ink transition-colors hover:text-teal" data-id="element-468" data-mp="lngblexzsbmd">
              hello@lentic.ai
            </a>
            <p className="mt-3 text-[15px] text-graphite" data-id="element-469" data-mp="1e7oj1wp5g3a8">
              London, United Kingdom
            </p>
            <a href="/#contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-base font-semibold text-bone transition-colors hover:bg-teal" data-id="element-470" data-mp="19e2eysx1x7q1">
              See pilot pricing
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-471" data-mp="38o54i80d51hb" />
            </a>
          </div>
        </div>
      </section>
    </>;
}